export default __webpack_public_path__ + "static/media/ic_item_badge@3x.c615c089.png";